import type { MaterialIcons } from "@/types/materialIcons"
import type { HTMLAttributes, ReactElement } from "react"

interface IconProps extends HTMLAttributes<HTMLDivElement> {
	name: MaterialIcons | ReactElement
	size?: number
}

const Icon = ({ name, size, ...props }: IconProps): ReactElement => (
	<div
		translate="no"
		{...props}
		className={["icon", props.className].filter((e) => e).join(" ")}
		style={{ fontSize: size, width: size, height: size, ...props.style }}
	>
		{name}
	</div>
)

export default Icon
